import { useState } from "react";
import { inputCls, labelCls, FormActions } from "./common";

const vide = { annee: new Date().getFullYear(), titre: "", points_saillants: "" };

export const RapportForm = ({ initial, onSave, onCancel, saving }) => {
  const [f, setF] = useState(
    initial ? { ...initial, points_saillants: initial.points_saillants.join("\n") } : vide
  );
  const set = (champ) => (e) => setF({ ...f, [champ]: e.target.value });

  const soumettre = (e) => {
    e.preventDefault();
    onSave({
      annee: Number(f.annee),
      titre: f.titre,
      points_saillants: f.points_saillants.split(/\n+/).map((s) => s.trim()).filter(Boolean),
    });
  };

  return (
    <form onSubmit={soumettre} className="space-y-5" data-testid="rapport-form">
      <div className="grid gap-5 md:grid-cols-3">
        <div>
          <label htmlFor="rf-annee" className={labelCls}>Année *</label>
          <input id="rf-annee" required type="number" min="2000" max="2100" value={f.annee} onChange={set("annee")} className={inputCls} data-testid="rapport-form-annee" />
        </div>
        <div className="md:col-span-2">
          <label htmlFor="rf-titre" className={labelCls}>Titre *</label>
          <input id="rf-titre" required minLength={3} value={f.titre} onChange={set("titre")} className={inputCls} placeholder="Rapport annuel 2026 — …" data-testid="rapport-form-titre" />
        </div>
      </div>
      <div>
        <label htmlFor="rf-points" className={labelCls}>Points saillants * (un par ligne)</label>
        <textarea id="rf-points" required rows={6} value={f.points_saillants} onChange={set("points_saillants")} className={`${inputCls} resize-y`} data-testid="rapport-form-points" />
      </div>
      <FormActions saving={saving} onCancel={onCancel} />
    </form>
  );
};
